import { useTranslation } from 'react-i18next'
import { Dispatch, SetStateAction } from 'react'

interface Props {
  setListFromFile: Dispatch<SetStateAction<File | undefined>>
}

function UploadMailingList({ setListFromFile }:Props) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-3">
      <label htmlFor="uploadList" className="text-[#2571C6] cursor-pointer underline text-sm">
        {t('insertList')}
        <input
          className="hidden"
          id="uploadList"
          type="file"
          accept=".xlsx"
          onChange={(e) => setListFromFile(e.target.files?.[0])}
        />
      </label>
      <p className="text-xs">{t('supportedMailingListFiles')}</p>
    </div>
  )
}

export default UploadMailingList
